import { gql } from '@apollo/client';

// OTRIX Play — librería de música relajante (player de prácticas + panel admin).

export const PLAY_MUSIC_TRACK_FIELDS = gql`
  fragment PlayMusicTrackFields on PlayMusicTrack {
    id
    title
    category
    duration_seconds
    file_url
    is_active
    position
  }
`;

export const PLAY_MUSIC_TRACKS = gql`
  query playMusicTracks($category: String) {
    playMusicTracks(category: $category) {
      ...PlayMusicTrackFields
    }
  }
  ${PLAY_MUSIC_TRACK_FIELDS}
`;

export const ADMIN_PLAY_MUSIC_TRACKS = gql`
  query adminPlayMusicTracks {
    adminPlayMusicTracks {
      ...PlayMusicTrackFields
    }
  }
  ${PLAY_MUSIC_TRACK_FIELDS}
`;

export const SAVE_PLAY_MUSIC_TRACK = gql`
  mutation savePlayMusicTrack($input: PlayMusicTrackInput!) {
    savePlayMusicTrack(input: $input) {
      ...PlayMusicTrackFields
    }
  }
  ${PLAY_MUSIC_TRACK_FIELDS}
`;

export const DELETE_PLAY_MUSIC_TRACK = gql`
  mutation deletePlayMusicTrack($id: ID!) {
    deletePlayMusicTrack(id: $id)
  }
`;

// Álbumes (playlists). `is_personal` distingue la playlist del cliente de la curada por OTRIX.
export const PLAY_MUSIC_ALBUM_FIELDS = gql`
  fragment PlayMusicAlbumFields on PlayMusicAlbum {
    id
    title
    category
    cover_url
    is_active
    position
    is_personal
    track_count
    total_seconds
    tracks {
      ...PlayMusicTrackFields
    }
  }
  ${PLAY_MUSIC_TRACK_FIELDS}
`;

export const PLAY_MUSIC_ALBUMS = gql`
  query playMusicAlbums {
    playMusicAlbums {
      ...PlayMusicAlbumFields
    }
  }
  ${PLAY_MUSIC_ALBUM_FIELDS}
`;

export const ADMIN_PLAY_MUSIC_ALBUMS = gql`
  query adminPlayMusicAlbums {
    adminPlayMusicAlbums {
      ...PlayMusicAlbumFields
    }
  }
  ${PLAY_MUSIC_ALBUM_FIELDS}
`;

export const SAVE_PLAY_MUSIC_ALBUM = gql`
  mutation savePlayMusicAlbum($input: PlayMusicAlbumInput!) {
    savePlayMusicAlbum(input: $input) {
      ...PlayMusicAlbumFields
    }
  }
  ${PLAY_MUSIC_ALBUM_FIELDS}
`;

export const DELETE_PLAY_MUSIC_ALBUM = gql`
  mutation deletePlayMusicAlbum($id: ID!) {
    deletePlayMusicAlbum(id: $id)
  }
`;

export const UPLOAD_PLAY_LIBRARY_MEDIA = gql`
  mutation uploadPlayLibraryMedia($file: Upload!) {
    uploadPlayLibraryMedia(file: $file) {
      url
    }
  }
`;
